module.exports = __webpack_public_path__ + "static/media/kmclogo.5c61f4ff.png";